import { useEffect, useState } from "react";
import metaDataServices from "../MetaDataServices";
import CueSerieUpsert from "./cueSerie_upsert";
import CustomFilter from "../Custom_Filter";
import DeleteDialogueBox from "components/Common/deleteDialogue";

export default function CueSeries(subEntity: any) {

    let [cueOpen, SetcueOpen] = useState(false);
    var payLoad = { pageNumber: 1, pageSize: 10 } 
    let [cuelistCount, SetcuelistCount] = useState(0);
    let [deleteRow, SetDeleteRow] = useState<any>([]);
    let [cueUpsert, SetcuelUpsert] = useState<any>([]);
    let [deleteConfirm, SetDeleteConfirm] = useState(false);
    let [cueSeriesist, SetcuePSerieslist] = useState<any>([]);
    let [cueProductlist, SetcueProductlist] = useState<any>([]);
    let [CustomFilterOpen, SetCustomFilterOpen] = useState(false);

    const onChangecueUpsert = (e: any) => {
        console.log(e)
        cueOpen = false;
        SetcueOpen(cueOpen)
        apiCall();
    }

    const openCueEdit = (e: any) => {
        cueUpsert = e;
        SetcuelUpsert(e)
        cueOpen = true;
        SetcueOpen(cueOpen)
    }

    useEffect(() => {
        apiCall();
    }, [subEntity])

    const apiCall = () => {
        metaDataServices.cueSerieslistSearch(payLoad).then((res:any) => {
            cueSeriesist = res
            SetcuePSerieslist(cueSeriesist);
            cuelistCount = res[0]?.totalRows ?? 0
            SetcuelistCount(cuelistCount)
        })
    }

    const onChangeCustomFilter = (e: any) => {
        CustomFilterOpen = false;
        SetCustomFilterOpen(CustomFilterOpen)
    }

    const deleteConfirmation = (e: any) => {
        console.log(e)
        console.log(deleteRow)
        if (e == 1) {
            metaDataServices.cueDelete(deleteRow.cueId).then((res:any) => {
                apiCall();
            })
        }

        deleteConfirm = false;
        SetDeleteConfirm(deleteConfirm)
    }

    let [searchFor, SetSearch] = useState("");
    let [activitySelection, SetactivitySelection] = useState("");
    let [statusSelection, SetStatusSelection] = useState("");
    let [updatedSelection, SetupdatedSelection] = useState("");

    const clearFilter = () => {
        searchFor = '';
        SetSearch(searchFor)

        activitySelection = '';
        SetactivitySelection(activitySelection)

        statusSelection = '';
        SetStatusSelection(statusSelection)

        updatedSelection = '';
        SetupdatedSelection(updatedSelection)
    }
    return (<>

        <div className="ws-12 ps">

            <div className='ws-12 box mbl'>
                <div className='ws-12 pm'>

                    <div className='w-75'>
                        <div className='ws-6 box ps height40'>
                            <input type="text" className="ws-12 pull-right height30" value={searchFor} onChange={(e) => SetSearch(e.target.value)}
                                placeholder='Search by Master Cue, Cue Theme' style={{ border: 'none', outline: 'none' }} />
                        </div>

                        <select className='pm pbl height40 grey text-bold icon-btn info' value={statusSelection} onChange={(e: any) => SetStatusSelection(e.target.value)}>
                            <option value={'All'}> All</option>
                            <option value={'BECS Member'}> Cue Member</option>
                        </select>

                        <button className='pm pbl height40 width90 white text-bold icon-btn info' onClick={() => SetCustomFilterOpen(true)}>
                            Filter
                        </button>
                    </div>

                    {(searchFor.length > 0 || statusSelection.length > 0 || activitySelection.length > 0 || updatedSelection.length > 0) &&
                        <button type="button" className="text-bold icon-btn delete height40 mr pull-left width70" onClick={clearFilter}>Clear</button>}
                    <button type="button" className="text-bold icon-btn edit pull-right height40" onClick={() => openCueEdit({})}>New Cue Serie</button>
                    <button type="button" className="text-bold icon-btn info pull-right height40" >Export</button>
                </div>
            </div>

            {(searchFor.length > 0 || statusSelection.length > 0 || activitySelection.length > 0 || updatedSelection.length > 0) && <div className='ws-12 pm'>

                <div className='ws-12 box landing pm text-center'>
                    {searchFor.length > 0 && <>
                        <span className='text-bold mr'>Search : </span>
                        <span className='mr'>{searchFor} </span>
                    </>}

                    {statusSelection.length > 0 && <>
                        <span className='text-bold mr'>Status :</span>
                        <span className='mr'>{statusSelection}</span>
                    </>}

                    {activitySelection.length > 0 && <>
                        <span className='text-bold mr'>Activity :</span>
                        <span className='mr'>{activitySelection}</span>
                    </>}
                    {updatedSelection.length > 0 && <>
                        <span className='text-bold mr'>Updated :</span>
                        <span className='mr'>{updatedSelection}</span>
                    </>}
                </div>

            </div>}

            <div className="ws-12"> 

                <table className="newTable">
                    <thead>
                        <tr>
                            <th >Cue SheetType</th>
                            <th >Series Name</th>
                            <th >Series Production Num</th>
                            <th >Series Category</th>
                            <th >Series Version</th>
                            <th >Series Duration</th>
                            <th >Series Language</th>
                            <th style={{ width: "14%" }}>Operations</th>
                        </tr>
                    </thead>
                    <tbody>

                        {cueSeriesist.map((row: any) => (
                            <tr>
                                <td>{row.cueSheetType}</td>
                                <td>{row.seriesName}</td>
                                <td>{row.seriesProductionNum}</td>
                                <td>{row.seriesCategory}</td>
                                <td>{row.seriesVersion}</td>
                                <td>  {String(row.seriesDurationMinute).padStart(2, '0')} : {String(row.seriesDurationSecond).padStart(2, '0')}  </td>
                                <td>{row.seriesLanguage}</td>
                                <td>
                                    <button className="icon-btn edit" title="Edit" type="button" onClick={() => openCueEdit(row)}>
                                        <i className="icon-pencil"> </i>
                                    </button>

                                    <button className="icon-btn delete" title="Delete" type="button" onClick={() => { SetDeleteConfirm(true); SetDeleteRow(row) }}>
                                        <i className="icon-trash"> </i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>

                </table>

            </div>

            {
                (() => {
                    if (cueOpen) {
                        return <CueSerieUpsert onChange={onChangecueUpsert} cueUpsert={cueUpsert} cueOpen={cueOpen} />
                    }
                    if (CustomFilterOpen) {
                        return <CustomFilter onChange={onChangeCustomFilter} CustomFilterOpen={CustomFilterOpen} type="CueListing" />
                    }

                    if (deleteConfirm) {
                        return <DeleteDialogueBox param={true} message={"to remove this cue serie"} onChange={deleteConfirmation} />
                    }
                })()
            }
        </div>


    </>)

}